import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { SpecialZoomLevel, Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';

import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';

import termsPdfUrl from '../assets/kol-torah-terms-hebrew.pdf';

// Worker must match pdfjs-dist version (3.4.120)
const WORKER_URL = `https://unpkg.com/pdfjs-dist@3.4.120/build/pdf.worker.min.js`;

const PdfViewPage: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t, i18n } = useTranslation();

  const isRtl =
    i18n.language?.toLowerCase().startsWith('he') || i18n.language?.toLowerCase().startsWith('iw');
  const dir = isRtl ? 'rtl' : 'ltr';

  const state = location.state as { pdfUrl?: string; titleKey?: string } | null;
  const pdfUrl = state?.pdfUrl ?? termsPdfUrl;
  const titleKey = state?.titleKey ?? 'terms_of_use';

  const defaultLayoutPluginInstance = defaultLayoutPlugin({
    sidebarTabs: () => [],
  });

  return (
    <div
      className="flex flex-col h-full bg-white overflow-hidden"
      style={{ width: '100%', minWidth: 0, maxWidth: '100vw' }}
      dir={dir}
    >
      <header
        style={{
          flexShrink: 0,
          display: 'flex',
          alignItems: 'center',
          padding: '12px 16px',
          borderBottom: '1px solid rgba(0,0,0,0.08)',
          background: '#FDF9F3',
        }}
      >
        <button
          type="button"
          onClick={() => navigate(-1)}
          style={{
            padding: '8px',
            border: 'none',
            background: 'transparent',
            cursor: 'pointer',
            fontSize: '15px',
            color: 'rgba(63, 71, 86, 0.9)',
            fontWeight: 500,
            display: 'flex',
            alignItems: 'center',
            gap: '6px',
          }}
        >
          {isRtl ? (
            <>
              <span aria-hidden>→</span>
              {t('back')}
            </>
          ) : (
            <>
              <span aria-hidden>←</span>
              {t('back')}
            </>
          )}
        </button>
      </header>
      <div
        style={{
          flex: 1,
          minHeight: 0,
          width: '100%',
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
        role="main"
        aria-label={t(titleKey) ?? undefined}
      >
        <Worker workerUrl={WORKER_URL}>
          <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
            <Viewer
              fileUrl={pdfUrl}
              plugins={[defaultLayoutPluginInstance]}
              defaultScale={SpecialZoomLevel.PageWidth}
              renderLoader={() => (
                <div
                  style={{
                    alignItems: 'center',
                    display: 'flex',
                    height: '100%',
                    justifyContent: 'center',
                    padding: 24,
                  }}
                >
                  {t('loading')}…
                </div>
              )}
            />
          </div>
        </Worker>
      </div>
    </div>
  );
};

export default PdfViewPage;
